import { createContext } from "react";

interface FormControlRef {
    validate: (value: unknown) => boolean;
    name: string;
}

interface FormContextValue {
    addControl: (id: string, control: FormControlRef) => void;
}

const FormContext = createContext<FormContextValue | null>(null);

export default FormContext;
